
import { TranslationSet } from '../types';

export const signup: TranslationSet = {
  'signup.title': {
    en: 'Sign Up',
    ja: 'サインアップ',
    es: 'Registrarse',
    zh: '注册',
    fa: 'ثبت نام'
  },
  'signup.subtitle': {
    en: 'Create an account to start documenting your baby\'s journey.',
    ja: '赤ちゃんの旅を記録するためのアカウントを作成しましょう。',
    es: 'Crea una cuenta para empezar a documentar tu viaje de bebé.',
    zh: '创建一个账户开始记录您的宝宝旅程。',
    fa: 'یک حساب کاربری ایجاد کنید تا ثبت سفر رشد کودک خود را شروع کنید.'
  },
  'signup.form.name': {
    en: 'Name',
    ja: '名前',
    es: 'Nombre',
    zh: '名字',
    fa: 'نام'
  },
  'signup.form.email': {
    en: 'Email',
    ja: 'メールアドレス',
    es: 'Correo electrónico',
    zh: '电子邮件',
    fa: 'ایمیل'
  },
  'signup.form.password': {
    en: 'Password',
    ja: 'パスワード',
    es: 'Contraseña',
    zh: '密码',
    fa: 'رمز عبور'
  },
  'signup.form.confirmPassword': {
    en: 'Confirm Password',
    ja: 'パスワードを確認',
    es: 'Confirmar contraseña',
    zh: '确认密码',
    fa: 'تایید رمز عبور'
  },
  'signup.form.signup': {
    en: 'Sign Up',
    ja: 'サインアップ',
    es: 'Registrarse',
    zh: '注册',
    fa: 'ثبت نام'
  },
  'signup.alreadyHaveAccount': {
    en: 'Already have an account?',
    ja: 'すでにアカウントをお持ちですか？',
    es: '¿Ya tienes una cuenta?',
    zh: '已经有账户了吗？',
    fa: 'قبلاً حساب کاربری دارید؟'
  },
  'signup.login': {
    en: 'Login',
    ja: 'ログイン',
    es: 'Iniciar sesión',
    zh: '登录',
    fa: 'ورود'
  },
  'signup.passwordMismatch': {
    en: 'Passwords do not match',
    ja: 'パスワードが一致しません',
    es: 'Las contraseñas no coinciden',
    zh: '密码不匹配',
    fa: 'رمزهای عبور مطابقت ندارند'
  },
  'signup.errorMessage': {
    en: 'Failed to create an account. Please try again.',
    ja: 'アカウントの作成に失敗しました。もう一度お試しください。',
    es: 'Error al crear la cuenta. Por favor, inténtalo de nuevo.',
    zh: '创建账户失败。请重试。',
    fa: 'ایجاد حساب با خطا مواجه شد. لطفا دوباره تلاش کنید.'
  }
};
